<template>
  <div class="login-wrap">
    <div class="login-card">
      <h2>账号登录</h2>
      <div class="input-item">
        <label>账号</label>
        <input v-model="username" placeholder="请输入账号" />
      </div>
      <div class="input-item">
        <label>密码</label>
        <input v-model="password" type="password" placeholder="请输入密码" />
      </div>
      <button class="login-btn" @click="submitLogin">登录</button>
    </div>
  </div>
</template>

<script>
import { loginFetch } from "@/utils/request";
export default {
  name: "ELogin",
  data() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    async submitLogin() {
      if (!this.username.trim() || !this.password.trim()) {
        alert("账号密码不能为空");
        return;
      }
      try {
        const res = await loginFetch({
          username: this.username,
          password: this.password
        });
        if (res.code === 0) {
          localStorage.setItem("readerToken", res.data.token);
          localStorage.setItem("readerId", res.data.readerId);
          this.$router.replace("/read");
        } else {
          alert(res.msg || "账号或密码错误");
        }
      } catch (err) {
        console.error("登录请求失败：", err);
        alert("网络异常，请重试");
      }
    }
  }
};
</script>

<style scoped>
.login-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #cfdfef;
  z-index: 999;
  overflow-y: auto;

  display: flex;
  align-items: center;
  justify-content: center;
}
.login-card {
  width: 270px;
  background: #fff;
  padding: 40px 30px;
  border-radius: 12px;
}
h2 {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}
.input-item {
  margin-bottom: 20px;
}
.input-item label {
  display: block;
  margin-bottom: 8px;
  color: #555;
}
.input-item input {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
}
.login-btn {
  width: 100%;
  padding: 13px;
  background: #7b61ff;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
}
</style>